// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmallConfigLicht_licht__pWb91 {
    flex: 1 1;
    position: relative;
}
.SmallConfigLicht_headline__Rrqfm {
    align-self: stretch;
    height: 39px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
}
.SmallConfigLicht_sonnenaufgang__ye0bo {
    align-self: stretch;
    position: relative;
}
.SmallConfigLicht_div__nFgNK {
    position: relative;
}
.SmallConfigLicht_timeClockCircleStreamlineIcon__3sKZS {
    width: 14px;
    position: relative;
    height: 14px;
    overflow: hidden;
    flex-shrink: 0;
}
.SmallConfigLicht_parent__D9MDJ {
    align-self: stretch;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 6px 8px;
    font-size: 14px;
}
.SmallConfigLicht_sonnenaufgangParent__MAQFv {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 7px;
}
.SmallConfigLicht_frameParent__f4VqP {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 21px;
}
.SmallConfigLicht_frameChild__BQt3A {
    width: 5.8px;
    position: relative;
    height: 3.2px;
}
.SmallConfigLicht_lightConfig__3p0OT {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 21px;
}
.SmallConfigLicht_config__ttG7e {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #cbd6e9;
}
.SmallConfigLicht_graphChild__ias5P {
    align-self: stretch;
    position: relative;
    max-width: 100%;
    overflow: hidden;
    height: 92px;
    flex-shrink: 0;
}
.SmallConfigLicht_frameDiv__GdqbF {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
}
.SmallConfigLicht_graph__WeDIJ {
    align-self: stretch;
    border-radius: 6px;
    background-color: #121823;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 30px 10px 10px;
    gap: 7px;
    font-size: 10px;
    color: #a7a7a7;
}
.SmallConfigLicht_cardLicht__LLypM {
    width: 100%;
    position: relative;
    border-radius: 6px;
    background-color: #0f141c;
    border: 1px solid #222d41;
    box-sizing: border-box;
    height: 740px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px 10px;
    gap: 30px;
    min-width: 300px;
    max-width: 380px;
    text-align: left;
    font-size: 21px;
    color: #fff;
    font-family: 'Noto Sans';
}

`, "",{"version":3,"sources":["webpack://./src/css/SmallConfigLicht.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,mBAAmB;;IAEnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,QAAQ;AACZ;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;AACb;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,wBAAwB;AAC5B","sourcesContent":[".licht {\n    flex: 1;\n    position: relative;\n}\n.headline {\n    align-self: stretch;\n    height: 39px;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n}\n.sonnenaufgang {\n    align-self: stretch;\n    position: relative;\n}\n.div {\n    position: relative;\n}\n.timeClockCircleStreamlineIcon {\n    width: 14px;\n    position: relative;\n    height: 14px;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n.parent {\n    align-self: stretch;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 8px;\n    font-size: 14px;\n}\n.sonnenaufgangParent {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 7px;\n}\n.frameParent {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 21px;\n}\n.frameChild {\n    width: 5.8px;\n    position: relative;\n    height: 3.2px;\n}\n.lightConfig {\n    align-self: stretch;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 21px;\n}\n.config {\n    align-self: stretch;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    color: #cbd6e9;\n}\n.graphChild {\n    align-self: stretch;\n    position: relative;\n    max-width: 100%;\n    overflow: hidden;\n    height: 92px;\n    flex-shrink: 0;\n}\n.frameDiv {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n.graph {\n    align-self: stretch;\n    border-radius: 6px;\n    background-color: #121823;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 30px 10px 10px;\n    gap: 7px;\n    font-size: 10px;\n    color: #a7a7a7;\n}\n.cardLicht {\n    width: 100%;\n    position: relative;\n    border-radius: 6px;\n    background-color: #0f141c;\n    border: 1px solid #222d41;\n    box-sizing: border-box;\n    height: 740px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 20px 10px;\n    gap: 30px;\n    min-width: 300px;\n    max-width: 380px;\n    text-align: left;\n    font-size: 21px;\n    color: #fff;\n    font-family: 'Noto Sans';\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"licht": `SmallConfigLicht_licht__pWb91`,
	"headline": `SmallConfigLicht_headline__Rrqfm`,
	"sonnenaufgang": `SmallConfigLicht_sonnenaufgang__ye0bo`,
	"div": `SmallConfigLicht_div__nFgNK`,
	"timeClockCircleStreamlineIcon": `SmallConfigLicht_timeClockCircleStreamlineIcon__3sKZS`,
	"parent": `SmallConfigLicht_parent__D9MDJ`,
	"sonnenaufgangParent": `SmallConfigLicht_sonnenaufgangParent__MAQFv`,
	"frameParent": `SmallConfigLicht_frameParent__f4VqP`,
	"frameChild": `SmallConfigLicht_frameChild__BQt3A`,
	"lightConfig": `SmallConfigLicht_lightConfig__3p0OT`,
	"config": `SmallConfigLicht_config__ttG7e`,
	"graphChild": `SmallConfigLicht_graphChild__ias5P`,
	"frameDiv": `SmallConfigLicht_frameDiv__GdqbF`,
	"graph": `SmallConfigLicht_graph__WeDIJ`,
	"cardLicht": `SmallConfigLicht_cardLicht__LLypM`
};
export default ___CSS_LOADER_EXPORT___;
